export enum PartnersEnum {
  POS = 0,
  EMBARGO = 1,
  SQUARE = 2,
  WOLT = 3,
  EPOSNOW = 4,
  UBER_EATS = 5,
  DELIVEROO = 6,
  GOODTILL = 7,
  BOLT = 8,
  SLACK = 9,
  LIGHT_SPEED = 10,
  GLOVO = 11,
  DOTYPOS = 12,
  WORLDPAY = 13,
  ZETTLE = 14,
  SUMUP = 15,
  XERO = 16,
  FOURTH = 17,
  WEALTHON = 18,
  KIOSK = 19,
  SQUARE_PAYMENT = 20,
  EMBARGO_PAY = 21,
  JUSTEAT = 22,
  VERIFACTU = 23,
}
